import React, { useState, useEffect } from 'react';
import { Box, Typography, IconButton, Fade, Card, CardContent } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const promotions = [
    {
        title: 'FREE Dryer Uses!',
        description: 'Get 30 min FREE dryer usage for every 30LB & 40LB Wash, and 1 hour FREE dryer usage for every 60LB & 90LB Wash!',
        image: '/Promo1.png',
    },
];

const PromotionsCarousel: React.FC = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const theme = useTheme();

    // Automatically cycle through promotions every 5 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex === promotions.length - 1 ? 0 : prevIndex + 1));
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    const handleArrowClick = (direction: 'prev' | 'next') => {
        setCurrentIndex((prevIndex) =>
            direction === 'prev'
                ? prevIndex === 0 ? promotions.length - 1 : prevIndex - 1
                : prevIndex === promotions.length - 1 ? 0 : prevIndex + 1
        );
    };

    return (
        <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
            <Card
                sx={{
                    width: '100%',
                    minHeight: '200px',
                    boxShadow: 3,
                    borderRadius: '10px',
                    overflow: 'hidden',
                    padding: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    backgroundColor: theme.palette.background.default, 
                }}
            >
                <CardContent
                    sx={{
                        textAlign: 'center',
                        maxHeight: '150px', 
                        overflowY: 'auto',
                    }}
                >
                    <Fade in key={currentIndex} timeout={500}>
                        <Box>
                            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                                {promotions[currentIndex].title}
                            </Typography>
                            <Typography variant="body2">
                                {promotions[currentIndex].description}
                            </Typography>
                        </Box>
                    </Fade>
                </CardContent>
            </Card>

            <IconButton onClick={() => handleArrowClick('prev')}
                sx={{
                    position: 'absolute',
                    left: -20,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    backgroundColor: theme.palette.background.paper,
                    '&:hover': { backgroundColor: theme.palette.primary.main },
                }}
            >
                <ArrowBackIcon />
            </IconButton>
            <IconButton onClick={() => handleArrowClick('next')}
                sx={{
                    position: 'absolute',
                    right: -20,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    backgroundColor: theme.palette.background.paper,
                    '&:hover': { backgroundColor: theme.palette.primary.main },
                }}
            >
                <ArrowForwardIcon />
            </IconButton>
        </Box>
    );
};

export default PromotionsCarousel;
